import React from 'react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-3',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  className,
  size = 'md'
}) => (
  <div 
    className={cn(
      'animate-spin rounded-full border-primary border-t-transparent',
      sizeClasses[size],
      className
    )}
    role="status"
    aria-label="Loading"
  />
); 